export const skillTag = 'skill:';
